import { useLocalObservable } from 'mobx-react';
import React, { createContext, ReactNode } from 'react';
import { BiApi, NoteApi } from '../../api-client';
import { AuthContext } from '../Auth/auth.provider';
import useStore from '../../helpers/useStore';
import { createApiConfig } from '../../api/createApiConfig';
import { PatientsContext } from '../Patients/patients.provider';
import BIStore from './biDashboardStore';



interface BIProviderProps {
  children: ReactNode;
}

export const BIContext = createContext<BIStore | null>(null);
BIContext.displayName = 'BIContext';

export const BIProvider = ({ children }: BIProviderProps) => {
const AuthenticationStore = useStore(AuthContext);

  const apiClient = new BiApi(createApiConfig());

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const store = useLocalObservable(
    () => new BIStore(apiClient,AuthenticationStore)
  );

//   store.apiClient = apiClient;

  return (
    <BIContext.Provider value={store}>
      {children}
    </BIContext.Provider>
  );
};